export default __webpack_public_path__ + "static/media/signal.9febb0d6.png";